<template>
  <div>
    <el-dialog
      :visible="addUseVisible"
      title="添加模拟用户"
      width="400px"
      @close="closeDialog"
      :before-close="closeDialog"
    >
      <el-form
        ref="elForm"
        :model="updateForm"
        size="medium"
        label-width="50px"
        :rules="rules"
      >
        <el-row :gutter="15">
          <el-form-item label="ID" prop="id">
            <el-input v-model="updateForm.id" disabled> </el-input>
          </el-form-item>

          <el-form-item label="账号" prop="account">
            <el-input v-model="updateForm.account">
              <el-select
                v-model="updateForm.telCountryCode"
                slot="append"
                v-if="!isEmail"
              >
                <el-option
                  v-for="(n, index) in countryCodeList"
                  :key="index"
                  :label="`+${n.code}${n.zh}`"
                  :value="n.code"
                >
                </el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item label="密码" prop="pwd">
            <el-input v-model="updateForm.pwd" type="password"> </el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSave('elForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import encrypt from '@/utils/encrypt'

export default {
  name: 'AddUserDialog',
  props: ['id'],
  data() {
    return {
      updateForm: {
        id: '',
        account: '',
        telCountryCode: '86',
        pwd: '',
      },

      rules: {
        // id: [
        //   {
        //     required: true,
        //     message: '请输入id',
        //     trigger: 'blur',
        //   },
        // ],
        account: [
          {
            required: true,
            message: '请输入账号',
            trigger: 'blur',
          },
        ],
        // telCountryCode: [
        //   {
        //     required: false,
        //     message: '请输入手机号',
        //     trigger: 'blur',
        //   },
        // ],
        pwd: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {
    id: {
      handler(val) {
        this.updateForm = { ...this.updateForm, id: val }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState('partnerList', ['addUseVisible', 'countryCodeList']),
    isEmail() {
      return this.updateForm.account.includes('@')
    },
  },
  methods: {
    ...mapMutations('partnerList', ['setAddUser']),
    ...mapActions('partnerList', ['addUser', 'fetchCoutryCode']),
    closeDialog() {
      this.updateForm.telCountryCode = '86'
      this.$refs['elForm'].resetFields()
      this.setAddUser(false)
    },

    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            id: Number(this.updateForm.id),
            account: this.updateForm.account,
            telCountryCode: this.updateForm.telCountryCode,
            // pwd: encrypt(this.updateForm.pwd),
            pwd: this.updateForm.pwd,
          }
          this.addUser(data).then((res) => {
            if (res.code == 0) {
              this.$message.success('添加成功')
              this.closeDialog()
            }
          })
        } else {
          return false
        }
      })
    },
  },
  mounted() {
    this.fetchCoutryCode()
  },
}
</script>

<style lang="less" scoped>
::v-deep.el-select {
  .el-input__inner {
    width: 120px;
  }
}
</style>
